import Styled, { css } from 'styled-components';

import { media } from '../../../../lib/StyledComponents';
import SVGIcon, { ISVGIconProps } from '../../../Icon/SVGIcon';

export const TaskIcon = Styled(SVGIcon)<ISVGIconProps>`
  width: 18px;
  height: 18px;
  fill: currentColor;
  position: relative;
  top: 5px;
  display: flex;
  align-content: center;
  align-items: center;

  ${media.small`
    width: 50px;
    height: 45px;
    top: 0;
  `}

  svg {
    height: 100%;
  }

  // hasIcon
  ${({ theme: { taskCard }}) => !taskCard.hasIcon && css`
    display: none;
    margin-left: -1em; // overwrite margin-left on text w/ icon
  `};
`;
